<template lang="pug">
.banner
  .illustration
    .illustration-bg
  .container
    h1 轻松融合多家 CDN 服务
    p 衢州点智连云计算有限公司，可按任意比例配置调度各 CDN 厂商流量
    a.btn(href="http://console.oncdp.com/#/login",target="_blank") 立即体验
</template>

<script>
export default {
  name: 'banner'
}
</script>

<style lang="sass" scoped>
.banner
  position: relative
  // margin-top: -100px
  height: 540px
  background: linear-gradient(to bottom, #17bcfe, #7f5cff)

.container
  width: 1170px
  margin: 0 auto
  transform: translateY(230px)
  color: #ffffff

h1
  font-size: 45px

p
  font-size: 16px
  line-height: 3em

.btn
  display: inline-block
  margin-top: 20px
  width: 200px
  line-height: 52px
  text-align: center
  text-decoration: none
  border: 1px solid #ffffff
  border-radius: 5px
  color: #ffffff
  transition: all 0.4s ease-in
  &:hover
    background-color: #ffffff
    color: #6376FF

.illustration
  position: absolute
  width: 100%
  bottom: 0
  right: 0
  overflow: hidden
  .illustration-bg
    position: relative
    right: -114px
    margin: 0 auto
    width: 1170px
    height: 540px
    background-image: url('../assets/banner-bg.png')
    background-size: 720px
    background-position: right bottom
    background-repeat: no-repeat
</style>



// WEBPACK FOOTER //
// banner.vue?2882e0ff